/* eslint-disable react/no-danger */
import { Col, Row, SafeHtml, useScopedSelector } from 'ia-react-core';
import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PageMainTitle from '../../components/PageMainTitle';
import ContactUsTile from '../../components/ContactUsTile';
import Section from './Section';
import { TableOfContents } from '../../interfaces/TableOfContents';
import TableOfContentsResource, { TableOfContentsResourceInfo } from '../../components/TableOfContentsResource/TableOfContentsResource';
import ResourcesLoader from '../../components/Resource/ResourcesLoader';

export interface TableOfContentsPageProps {
  url: string;
  tableOfContentName: string;
}

const TableOfContentsPage: FC<TableOfContentsPageProps> = ({ url, tableOfContentName }) => {
  const { search } = useLocation();
  let tableOfContentsData: TableOfContents = useScopedSelector(`${TableOfContentsResourceInfo.dataDst}-${tableOfContentName}`);

  tableOfContentsData = { ...tableOfContentsData, items: tableOfContentsData?.items.filter((x) => search.includes(x.fields.queryParameters ?? '')) };

  useEffect(() => {
    const element = document.createElement('div');
    element.innerHTML = tableOfContentsData?.title;
    document.title = element.textContent;
  }, [tableOfContentsData?.title]);

  return (
    <ResourcesLoader>
      <ResourcesLoader.Resources>
        <TableOfContentsResource url={url} tableOfContentName={tableOfContentName} autoRequestIfEmpty />
      </ResourcesLoader.Resources>
      <ResourcesLoader.Content>
        <PageMainTitle><SafeHtml>{tableOfContentsData?.title}</SafeHtml> </PageMainTitle>
        <Row gutter={16}>
          <Col xs={12} lg={8}>
            <Section tableOfContentsData={tableOfContentsData} tableOfContentName={tableOfContentName} />
          </Col>
          <Col xs={12} lg={4}>
            <ContactUsTile />
          </Col>
        </Row>
      </ResourcesLoader.Content>
    </ResourcesLoader>

  );
};

export default TableOfContentsPage;
